import {createTheme} from "@material-ui/core/styles";
import {Theme} from "@material-ui/core";
import {BrandConfig} from "./modules/brand/BrandConfig";
import {currentBrand} from "./modules/brand/BrandContext";

/**
 * Builds the Material-UI theme from a brand.
 *
 * This was a module-level constant holding a hardcoded cyan, which is a large part of why a
 * second brand was impossible: palette.primary was fixed at build time along with everything else.
 *
 * primary.main uses the link color rather than the raw brand color. MUI applies primary to
 * small elements on white — text fields, helper text, links — where a published brand color may
 * not clear 4.5:1. The raw color stays available as primary.light for surfaces that want it.
 */
export function createBrandTheme(brand: BrandConfig): Theme {
    return createTheme({
        palette: {
            primary: {
                main: brand.theme.linkOnWhite,
                light: brand.theme.raw,
                dark: brand.theme.linkOnWhite,
                contrastText: brand.theme.onSurface
            }
        }
    });
}

/**
 * The theme for the brand this page was served with. Built once; the brand cannot change
 * without a page load. Kept as the default export so existing consumers — ThemeUtil and
 * SnackbarThemeHolder — pick up the brand without changes.
 */
const GLOBAL_THEME = createBrandTheme(currentBrand());

export default GLOBAL_THEME;
